/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

// export const APIHost = "https://mpexpert.aiandor.de/api/v1/";
// export const APIHost = "https://beta.aiandor.de/api/v1/";

// export const APIHost = "http://localhost:8080/api/v1/";
export const APIHost =  window.location.origin + "/api/v1/"